
import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchLanguages } from "slices/languageSlice";
import Api from "services/api"
import toast from "react-hot-toast";
import { ListLayout } from "components/common/ListLayout";
import TableHeaderItem from "components/common/ListLayout/TableHeaderItem";
import { Link } from "react-router-dom";
import { invoicesSelector } from "slices/invoiceSlice";
import { fetchAppointClientsListPage } from "slices/invoiceSlice";
import { userSelector } from "slices/userSlice";
import { fetchGeneratedInvoices } from "slices/invoiceSlice";
import { usePermissions } from "layouts/Admin";
import ConfirmationInvoice from "components/common/ConfirmationInvoiceGenerate";
const apiService = new Api();

function ClientInvoiceViewList({ filters, isCreatingInvoice, searchTerm, setSearchTerm }) {
    const dispatch = useDispatch()
    const { checkPermission } = usePermissions();
    const { appointClientsListPage, generatedInvoices, last_page: totalPages, loader, total, current_page, per_page: pageLength } = useSelector(invoicesSelector);
    const refAddutton = React.useRef(null);
    const [selectedItems, setSelectedItems] = React.useState([]);
    const [selectAll, setSelectAll] = React.useState(false);
    const [deleteModal, setDeleteModal] = React.useState(false);
    const [generateInvoice, setGenerateInvoice] = React.useState(false);
    const [itemId, setItemId] = React.useState(false);
    const [currentPage, setCurrentPage] = React.useState(1);
    const [sortConfig, setSortConfig] = React.useState({
        sortBy: 'name',
        sortDirection: 'asc',
    });
    const { user } = useSelector(userSelector);
    const userToken = user.token;

    React.useEffect(() => {
        dispatch(fetchAppointClientsListPage())
        dispatch(fetchGeneratedInvoices())
    }, [])

    const handleAddLanguagePopUp = (item) => {
        // setAddForm({
        //     show: true,
        //     item,
        // });
    };

    const submitCallback = (status, message) => {
        if (status) {
            toast.success(message, {
                className: "successToast",
            })
            setSelectedItems([]);
            setSelectAll(false)
            dispatch(fetchAppointClientsListPage())
            hideConfirmDialog()
        }
        else {
            toast.error(message,
                {
                    className: "errorToast",
                }
            );
        }
    };

    const showGenerateInvoiceDialog = (id) => {
        setGenerateInvoice(true);
        setItemId(id)
    }
    const hideInvoiceDialog = () => {
        setGenerateInvoice(false);
    }
    const hideConfirmDialog = () => {
        setDeleteModal(false);
    }

    const handleChange = (e) => {
        // handle form change
        const id = e.target.dataset.value
        setSelectedItems(
            selectedItems.includes(id) ?
                selectedItems.filter((item) => item != id) :
                [...selectedItems, id]
        )
    };
    const handleToggleSelectAll = () => {
        if (selectAll) {
            setSelectedItems([])
            setSelectAll(false)
            return
        }
        setSelectAll(true)
        setSelectedItems(appointClientsListPage?.map((val) => val.id.toString()))


    }


    //#region TABLE HEAD 

    const renderTableHeader = React.useCallback(() => {
        const callBack = (dir, sortBy) => {
            setSortConfig({ sortBy, sortDirection: dir })
            dispatch(fetchAppointClientsListPage(currentPage, { sortBy: sortBy, sortDirection: dir, search: searchTerm, ...filters }))
        }
        return (
            <tr>
                <th className="col-1">
                    <div className="row_check">
                        <span>#</span>
                    </div>
                </th>
                <th className="col-3">
                    <TableHeaderItem
                        title="Client Name"
                        sortBy="name"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th className="col-3">
                    Total Due Bill
                    {/* <TableHeaderItem
                        title="Total Due Bill"
                        sortBy="name"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    /> */}
                </th>

                <th className="col-3">
                    Number of Appointments
                    {/* <TableHeaderItem
                        title="Number of Appointments"
                        sortBy="created_at"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    /> */}
                </th>
                <th className="col-3">Number of Projects</th>
                {(checkPermission('Detail Billing') || checkPermission('Generate Invoices')) &&
                    <th className="col-2">Actions</th>
                }

            </tr>
        )
    }, [selectAll, searchTerm, sortConfig, currentPage, selectedItems, filters]);

    //#endregion


    //#region TABLE BODY

    const renderTableContent = React.useCallback(() => {
        return (
            appointClientsListPage?.map((item, index) => (
                <AppointClientItems invoice={generatedInvoices} data={item} userToken={userToken} index={index} selectedItems={selectedItems} handleChange={handleChange} handleAddPopUp={handleAddLanguagePopUp} current_page={current_page} pageLength={pageLength} checkPermission={checkPermission} showGenerateInvoiceDialog={showGenerateInvoiceDialog} filters={filters} />
            ))
        )
    }, [appointClientsListPage, selectedItems]);

    //#endregion


    return (
        <ListLayout
            time={false}
            addButtonDisabled={true}
            renderTableHeader={renderTableHeader}
            renderTableContent={renderTableContent}
            hideRemoveButton={true}
            invoiceButton={true}
            paginationParams={filters}
            totalPages={totalPages}
            fetchList={fetchAppointClientsListPage}
            selectedItems={selectedItems}
            refAddutton={refAddutton}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            loader={loader || isCreatingInvoice}
            noOfItems={total}
            searchPlaceholder="Search..."
            defaultPageLength={pageLength}
            sortConfig={sortConfig}
        >
            {generateInvoice && <ConfirmationInvoice onClose={hideInvoiceDialog} isOpen={generateInvoice} id={itemId} filters={filters} />}
        </ListLayout>
    )

}


const AppointClientItems = ({
    data, index, current_page, pageLength, checkPermission, showGenerateInvoiceDialog, filters
}) => {
    const serial = useMemo(() => {
        return index + 1 + (current_page - 1) * pageLength;
    }, [current_page, pageLength]);
    const TotalDueBill = data?.appointments?.reduce((total, i) => total + (i?.invoice?.total_amount || 0), 0).toFixed(2);
    console.log("TotalDueBill", TotalDueBill, data?.appointments, data?.appointments?.reduce((total, i) => total + (i?.invoice?.total_amount || 0), 0))
    const TotalProjectBill = Number(data?.total_project_bill || 0).toFixed(2);

    const filterParams = new URLSearchParams(
        Object.entries(filters || {}).filter(
            ([key, value]) => key !== 'client_ids' && value
        )
    ).toString();;

    return (
        <tr>
            <td>
                <div className="row_check">
                    <span>{serial}</span>
                </div>
            </td>
            <td>
                {data?.user?.name}
            </td>
            {/* <td>
                {TotalDueBill !== null && TotalDueBill !== undefined ? `$${TotalDueBill}` : 'N/A'}
            </td> */}
            <td>
                {TotalDueBill !== null && TotalDueBill !== undefined
                    ? `$${(Number(TotalDueBill) + Number(TotalProjectBill || 0)).toFixed(2)}`
                    : 'N/A'}
            </td>
            <td>
                {data?.appointments?.length}
            </td>
            <td>
                {data?.number_of_projects || 0}
            </td>
            {(checkPermission('Detail Billing') || checkPermission('Generate Invoices')) &&
                <td>
                    <div className="row_check">
                        {checkPermission('Detail Billing') &&
                            <Link to={`/billings/detail/${data?.id}${filterParams ? `?${filterParams}` : ''}`} target="_blank" className="table_edit">Details</Link>
                        }
                        {checkPermission('Generate Invoices') &&
                            <button onClick={() => showGenerateInvoiceDialog(data?.id)} className="main_button text-nowrap">Generate invoice</button>
                        }
                    </div>
                </td>
            }
        </tr>
    )
}


export default ClientInvoiceViewList;
